import buildCompanyName from '../../../utilities/buildCompanyName'
import { GetConsumerVoucher } from '../type'
import GeneralInformation from './GeneralInformation'
import ConsumerVoucherProducts from './ConsumerVoucherProducts'

export default function ModalInfo({ data }: { data: GetConsumerVoucher }) {
    return (
        <>
            <div className="body__head mb-4">
                <div className="title">
                    <h1>VALE DE CONSUMO {data.document.code}</h1>
                </div>
                <div>
                    <div className="company_badge">
                        <img
                            src={
                                data.company_warehouse.company.country.image_url
                            }
                        />
                        <b>
                            {buildCompanyName(
                                data.company_warehouse.company.name
                            )}
                        </b>
                    </div>
                </div>
            </div>
            <GeneralInformation data={data} />
            <ConsumerVoucherProducts data={data} />
        </>
    )
}
